import axios from "axios";

const adminAxios = axios.create({
  withCredentials: true,
});

adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const method = error.config?.method?.toUpperCase();
    const onLoginPage = window.location.pathname === "/login";

    if (error.response?.status === 429) {
      const retryAfter = error.response.headers["retry-after"];
      const retryAt = retryAfter ? Date.now() + parseInt(retryAfter, 10) * 1000 : null;
      window.dispatchEvent(new CustomEvent("app:rate-limited", { detail: { retryAt } }));
      return Promise.reject(error);
    }

    if (
      error.response?.status === 401 &&
      method === "GET" &&
      !onLoginPage
    ) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default adminAxios;
